import { bffApiService } from 'config/service';
import { urls } from 'constants/urls';

export interface IFeatureFlagrResponse {
  access: boolean;
}

const getUserHasFeature = (featureId: string): Promise<IFeatureFlagrResponse> =>
  bffApiService.get(`${urls.flagr.checkFeature}/${featureId}`);

export { getUserHasFeature };
